import { createApp } from 'vue';
import { IconFont } from '@nutui/icons-vue';
import App from './App.vue';
import 'animate.css';
import "@nutui/nutui/dist/style.css";
import '@nutui/icons-vue/dist/style_iconfont.css';
import 'intro.js/introjs.css';

createApp(App).use(IconFont).mount('#app')
